<template>
  <footer>
    <p>
      <span style="color: rgba(255, 255, 255, 0.6)">{{ nameLine }}</span>
      <span style="margin: 0 0.5rem; color: rgba(255, 255, 255, 0.2)">•</span>
      {{ titleLine }}
    </p>

    <nav class="footer-legal" aria-label="روابط الموقع">
      <template v-for="(link, i) in legalLinks" :key="i">
        <router-link :to="link.link">{{ link.label }}</router-link>
        <span v-if="i < legalLinks.length - 1" class="footer-legal-sep">•</span>
      </template>
    </nav>

    <div class="d-flex align-items-center gap-3">
      <p>{{ creditText }}</p>
      <ul class="social">
        <li v-for="(item, i) in socials" :key="i">
          <a :href="item.url" target="_blank" :aria-label="socialAriaLabel(item.icon)">
            <i :class="`pi pi-${item.icon}`"></i>
          </a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
const DEFAULT_LEGAL_LINKS = [
  { label: 'من نحن', link: '/about' },
  { label: 'المدونة', link: '/blogs' },
  { label: 'سياسة الخصوصية', link: '/privacy-policy' },
  { label: 'شروط الاستخدام', link: '/terms-of-service' },
];
const DEFAULT_SOCIALS = [
  { icon: 'facebook', url: 'https://facebook.com/ahmedhawam2030' },
  { icon: 'whatsapp', url: 'https://wa.me/+201280194879' },
  { icon: 'phone', url: 'tel:01280194879' },
];

export default {
  name: "AppFooter",
  props: {
    // Homepage Builder feature — global footer chrome, fetched once in
    // App.vue (not per-page). null until loaded, or if left unconfigured.
    settings: { type: Object, default: null },
  },
  computed: {
    nameLine() { return this.settings?.name_line || 'أ/ طارق عبدالغني عبدالباري'; },
    titleLine() { return this.settings?.title_line || 'مدرس الرياضيات'; },
    creditText() { return this.settings?.credit_text || 'Powered by Ahmed Hawam  ⚡'; },
    legalLinks() { return this.settings?.legal_links?.length ? this.settings.legal_links : DEFAULT_LEGAL_LINKS; },
    socials() { return this.settings?.socials?.length ? this.settings.socials : DEFAULT_SOCIALS; },
  },
  methods: {
    socialAriaLabel(icon) {
      return { facebook: 'Facebook', whatsapp: 'WhatsApp', phone: 'Phone' }[icon] || icon;
    },
  },
};
</script>

<style scoped>
.footer-legal {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
  font-family: 'Cairo', sans-serif;
  font-size: 0.85rem;
}
.footer-legal a {
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;
  font-weight: 700;
  transition: color 0.2s;
}
.footer-legal a:hover { color: #fff; }
.footer-legal-sep { color: rgba(255, 255, 255, 0.25); }
</style>
